export const SliderItems = [
  {
    id: 1,
    image:
      'https://cdn11.bigcommerce.com/s-9p889rxpkb/images/stencil/original/image-manager/hp-banner.gif?t=1669089944&_gl=1*1uc6apn*_ga*MTIzNjY1NjYwNy4xNjUyMTM3Njc4*_ga_WS2VZYPC6G*MTY2OTA4OTUzNi42MDguMS4xNjY5MDkwMDkyLjQ3LjAuMA.',
    title: 'Shop Our Holiday Shop',
    description:
      'Stock up on glow-giving skincare for everyone on your list. So Many Blissful Gifts To Give.',
    backcolor: 'ffc786',
    btnname: 'SHOP NOW',
    btnback: '#f4ea77',
    borderbottom: '#8cd0e3',
  },
  {
    id: 2,
    image:
      'https://cdn11.bigcommerce.com/s-9p889rxpkb/images/stencil/original/image-manager/holiday-ls-hp.jpg?t=1666217371&_gl=1*kn7ceb*_ga*MTIzNjY1NjYwNy4xNjUyMTM3Njc4*_ga_WS2VZYPC6G*MTY2NzMzNTE5My41MzkuMS4xNjY3MzQzMTM4LjQ4LjAuMA',
    title: 'Zest Gifts Ever',
    description:
      'Shop the scent that started it all with our indulgent Lemon Sage body care.',
    backcolor: 'c7e8f1',
    btnname: 'SHOP LEMON SAGE',
    btnback: '#8cd0e3',
    borderbottom: '#f4ea77',

  },
  {
    id: 3,
    image:
      'https://cdn11.bigcommerce.com/s-9p889rxpkb/images/stencil/original/image-manager/holiday-bright-hp.jpg?t=1667343081&_gl=1*1ugrkfk*_ga*MTIzNjY1NjYwNy4xNjUyMTM3Njc4*_ga_WS2VZYPC6G*MTY2NzMzNTE5My41MzkuMS4xNjY3MzQzMTM4LjQ4LjAuMA',
    title: 'All Is Bright',
    description:
      'Bright, glowing skin is always in! Give the gift that keeps on giving with our vitamin C collection.',
    backcolor: 'ffc786',
    btnname: 'SHOP BRIGHT IDEA',
    btnback: '#8cd0e3',
    borderbottom: '#f4ea77',

  },
];
